import { apiService } from "core/services/apiService";
 
// Commented out - employee-form API calls not needed
export const getSupplementFormsementForms = async (
    formId: string | number
): Promise<any | null> => {
    // try {
    //     const response = await apiService.get(`/employee-form/i9/supplement/translator/${formId}`);
    //     const data = apiService.responseHandler(response);
    //     return data;
    // } catch (error) {
    //     console.error('Error fetching supplement forms:', error);
    //     return null;
    // }
    return null;
};


// Commented out - employee-form API calls not needed
export const getEmployeeI9Form = async (employeeID: number | string): Promise<any> => {
    // const data = apiService.responseHandler(
    //     await apiService.get(`/employee-form/i9/${employeeID}`)
    // );
    // return data;
    return null;
};

// Commented out - employee-form API calls not needed
export const getEmployeeW4Form = async (employeeID: number | string): Promise<any> => {
    // const data = apiService.responseHandler(
    //     await apiService.get(`/employee-form/w4/${employeeID}`)
    // );
    // return data;
    return null;
};


// Commented out - employee-form API calls not needed
export const getEmployeePciComplianceForm = async (employeeID: number | string): Promise<any> => {
    // const data = apiService.responseHandler(
    //     await apiService.get(`/employee-form/pci-compliance/${employeeID}`)
    // );
    // return data;
    return null;
};
 